import axios from "axios";
import { useUserStateStore } from "../stores/userState";

// Axios 인스턴스 생성
const apiClient = axios.create({
  baseURL: import.meta.env.VITE_API_BASE_URL, // 스프링부트 기본 URL
  timeout: 5000, // 요청 타임아웃 (밀리초)
  // headers: {
  //   'Content-Type': 'application/json', // 기본 헤더
  // },
});

// 요청 인터셉터
apiClient.interceptors.request.use(
  (config) => {
    // 필요한 경우, 공통적으로 헤더에 API 키 추가
    const userState = useUserStateStore();
    const apiKey = userState.user.APIKey;

    if (apiKey) {
      config.headers["u2-api-key"] = apiKey; // API 키 헤더 추가
    }

    if (!config.headers["AssociationID"]) {
      // ✅ AssociationID가 없는 경우, userState에서 가져오기
      const defaultAssociationID = userState.user.AssociationID;
      if (defaultAssociationID) {
        config.headers["AssociationID"] = defaultAssociationID;
      }
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

// 응답 인터셉터
apiClient.interceptors.response.use(
  (response) => {
    return response.data; // 응답 데이터를 직접 반환
  },
  (error) => {
    // 에러 처리 (예: API KEY 없거나 다른 경우 경우)
    if (error.response && error.response.status === 401) {
      console.error("API KEY 불일치");
      // 바로 로그아웃하고 로그인 화면으로 이동 (중복 호출은 store 가 막는다)
      const userState = useUserStateStore();
      userState.logoutOnUnauthorized();
    }
    return Promise.reject(error);
  },
);

export default apiClient;
